<template>
    <div>
        <Header />
        <!-- Start Profile Area -->
        <section class="profile-area section" style="margin-top: 12px;">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-12 col-12">
                        <!-- Start Profile Card -->
                        <div class="profile-card">
                            <div class="profile-image">
                                <img :src="profileImage" alt="Profile Image">
                                <div class="upload-button">
                                    <input type="file" id="profileImageInput" @change="onFileSelect" />
                                    <label for="profileImageInput" class="btn btn-secondary">Cambiar Imagen</label>
                                </div>
                            </div>
                            <div class="profile-info">
                                <h4 class="name">{{ user.nombre }}</h4>
                                <p class="email">{{ user.email }}</p>
                                <p class="phone">{{ user.numeroCelular }}</p>
                                <!-- Mostrar tipo de usuario -->
                                <p class="type">
                                    Tipo de Usuario: {{ user.tipoUsuarioId === 1 ? 'Vendedor' : 'Comprador' }}
                                </p>
                                <button @click="toggleEditForm"
                                    :class="['btn', isEditing ? 'btn-danger' : 'btn-primary']">
                                    <i :class="iconClass"></i>&nbsp; {{ buttonText }}
                                </button>
                            </div>
                        </div>
                        <!-- End Profile Card -->

                        <!-- Start Profile Options -->
                        <div class="profile-options">
                            <h3>Opciones</h3>
                            <div class="options-grid">
                                <div v-for="option in options" :key="option.name" class="option-card"
                                    @click="navigateTo(option.route)">
                                    <i :class="option.icon"></i>
                                    <h4>{{ option.name }}</h4>
                                </div>
                            </div>
                        </div>
                        <!-- End Profile Options -->
                    </div>
                    <div class="col-lg-8 col-md-12 col-12">
                        <!-- Start Profile Edit Form -->
                        <div class="profile-edit-form" v-if="isEditing">
                            <form @submit.prevent="updateProfile">
                                <div class="form-section">
                                    <div class="d-flex">
                                        <h4 class="mb-2">Información Personal</h4>
                                        <a @click="toggleFormEditing"
                                            :class="['btn', formIsEditing ? 'btn-danger' : 'btn-primary']">
                                            <i :class="formButtonIcon"></i>&nbsp; {{ formButtonText }}
                                        </a>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="nombre">Nombre:</label>
                                                <input type="text" v-model="editProfileData.nombre" id="nombre"
                                                    :disabled="!formIsEditing" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="email">Email:</label>
                                                <input type="email" v-model="editProfileData.email" id="email" disabled
                                                    class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="numeroCelular">Número de Celular:</label>
                                                <input type="text" v-model="editProfileData.numeroCelular"
                                                    :disabled="!formIsEditing" id="numeroCelular"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="cedulaoRif">Cedula o RIF:</label>
                                                <input type="text" v-model="editProfileData.cedulaORif" id="direccion"
                                                    disabled class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="direccion">Dirección:</label>
                                                <input type="text" v-model="editProfileData.direccion" id="direccion"
                                                    :disabled="!formIsEditing" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="ciudad">Ciudad:</label>
                                                <input type="text" v-model="editProfileData.ciudad" id="ciudad"
                                                    :disabled="!formIsEditing" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="user.tipoUsuarioId === 1">
                                            <div class="form-group">
                                                <label for="numeroFijo">Número Fijo:</label>
                                                <input type="text" v-model="editProfileData.numeroFijo" id="numeroFijo"
                                                    :disabled="!formIsEditing" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="numeroWhatsapp">Número de Whatsapp:</label>
                                                <input type="text" v-model="editProfileData.numeroWhatsapp"
                                                    :disabled="!formIsEditing" id="numeroWhatsapp"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-section">
                                    <h4 class="mb-2 mt-2">Redes Sociales</h4>
                                    <div class="row">
                                        <div class="col-md-6" v-if="user.tipoUsuarioId === 1">
                                            <div class="form-group">
                                                <label for="paginaWeb">Pagina Web:</label>
                                                <input type="text" v-model="editProfileData.paginaWeb" id="idInstagram"
                                                    :disabled="!formIsEditing" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="idInstagram">ID Instagram:</label>
                                                <input type="text" v-model="editProfileData.idInstagram"
                                                    :disabled="!formIsEditing" id="idInstagram" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="idTikTok">ID TikTok:</label>
                                                <input type="text" v-model="editProfileData.idTikTok" id="idTikTok"
                                                    :disabled="!formIsEditing" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="nombreFacebook">Nombre Facebook:</label>
                                                <input type="text" v-model="editProfileData.nombreFacebook"
                                                    :disabled="!formIsEditing" id="nombreFacebook"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-section">
                                    <h4 class="mb-2 mt-2">Información Adicional</h4>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="nombreORazonSocial">Nombre o Razón Social:</label>
                                                <input type="text" v-model="editProfileData.nombreORazonSocial"
                                                    :disabled="!formIsEditing" id="nombreORazonSocial"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group" v-if="user.tipoUsuarioId === 1">
                                                <label for="nombreRepresentante">Nombre del Representante:</label>
                                                <input type="text" v-model="editProfileData.nombreRepresentante"
                                                    :disabled="!formIsEditing" id="nombreRepresentante"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="user.tipoUsuarioId === 1">
                                            <div class="form-group">
                                                <label for="cedulaRepresentante">Cedula del Representante:</label>
                                                <input type="text" v-model="editProfileData.cedula"
                                                    :disabled="!formIsEditing" id="nombreRepresentante"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="user.tipoUsuarioId === 1">
                                            <div class="form-group">
                                                <label for="numeroRepresentante">Numero de Telefono del
                                                    Representante:</label>
                                                <input type="text" v-model="editProfileData.numeroTelefono"
                                                    :disabled="!formIsEditing" id="nombreRepresentante"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="user.tipoUsuarioId === 1">
                                            <div class="form-group">
                                                <label for="cargoRepresentante">Cargo del Representante:</label>
                                                <input type="text" v-model="editProfileData.cargo"
                                                    :disabled="!formIsEditing" id="nombreRepresentante"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-primary" v-if="formIsEditing">Guardar
                                    Cambios</button>
                            </form>
                        </div>
                        <!-- End Profile Edit Form -->

                        <!-- Start Profile Info Area -->
                        <div class="profile-info-area" v-if="!isEditing">
                            <h3>¡Bienvenido a tu perfil, {{ user.nombre }}!</h3>
                            <p>Estamos encantados de tenerte aquí. Tu perfil es el centro de tu experiencia en nuestra
                                plataforma. Aquí puedes revisar y actualizar tu información personal, acceder a
                                configuraciones importantes y ajustar tus preferencias según tus necesidades.</p>
                            <p>Para comenzar, explora las siguientes opciones:</p>
                            <ul>
                                <li><strong>Información Personal:</strong> Actualiza tus datos de contacto y otra
                                    información relevante.</li>
                                <li><strong>Configuraciones de Cuenta:</strong> Ajusta tus preferencias de
                                    notificaciones y privacidad.</li>
                                <li><strong>Soporte:</strong> Accede a nuestra sección de ayuda para resolver cualquier
                                    duda o problema.</li>
                                <li><strong>Seguridad:</strong> Revisa y mejora la seguridad de tu cuenta con nuestras
                                    herramientas de protección.</li>
                            </ul>
                            <p>Si tienes alguna pregunta o necesitas asistencia, no dudes en ponerte en contacto con
                                nuestro equipo de soporte. ¡Estamos aquí para ayudarte!</p>
                        </div>
                        <!-- End Profile Info Area -->
                    </div>
                </div>
            </div>
        </section>
        <!-- End Profile Area -->

        <!-- Image Cropper Modal -->
        <div v-if="imageToCrop" class="cropper-modal">
            <div class="cropper-modal-content">
                <div class="cropper-container">
                     <Cropper
                        ref="cropperRef"
                        :src="imageToCrop"
                        :stencil-props="{
                            aspectRatio: 1/1
                        }"
                        :canvas="{
                            height: 400, // Max height for the canvas containing the image
                            width: '100%'
                        }"
                        style="max-height: 400px; width: 100%;"
                    />
                </div>
                <div class="cropper-actions">
                    <button @click="cropImage" class="btn btn-primary">Guardar</button>
                    <button @click="cancelCrop" class="btn btn-secondary">Cancelar</button>
                </div>
            </div>
        </div>
        <!-- End Image Cropper Modal -->

        <!-- ========================= scroll-top ========================= -->
        <a href="#" class="scroll-top">
            <i class="lni lni-chevron-up"></i>
        </a>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { PerfilService } from "@/services/PerfilService";
import { config } from '@/config';
import Swal from "sweetalert2";
import { Cropper } from 'vue-advanced-cropper'; // Import Cropper
import 'vue-advanced-cropper/dist/style.css';   // Import default styles


export default {
    name: 'ProfilePage',
    components: {
        Header,
        Cropper
    },
    data() {
        return {
            user: {
                nombre: '',
                email: '',
                numeroCelular: '',
                imagenPerfil: '',
                tipoUsuarioId: 0,
            },
            formIsEditing: false,
            isEditing: false,
            editProfileData: {
                nombre: '',
                email: '',
                cedulaORif: '',
                numeroCelular: '',
                direccion: '',
                ciudad: '',
                numeroFijo: '',
                numeroTelefono: '',
                numeroWhatsapp: '',
                paginaWeb: '',
                idInstagram: '',
                idTikTok: '',
                nombreFacebook: '',
                nombreORazonSocial: '',
                nombreRepresentante: '',
                correoElectronico: '',
                cargo: '',
                cedula: '',
            },
            profileImage: require('@/assets/perfil.png'),
            options: [
                { name: 'Configuraciones', route: '/settings', icon: 'lni lni-cog' },
                { name: 'Soporte', route: '/support', icon: 'lni lni-support' },
                { name: 'Seguridad', route: '/security', icon: 'lni lni-lock' },
            ],
            imageToCrop: null, 
            originalFile: null, 
        };
    },
    computed: {
        buttonText() {
            return this.isEditing ? 'Cancelar' : 'Ver Perfil';
        },
        iconClass() {
            return this.isEditing ? 'lni lni-close' : 'lni lni-eye';
        },
        formButtonText() {
            return this.formIsEditing ? 'Cancelar Edicion' : 'Editar Perfil';
        },
        formButtonIcon() {
            return this.formIsEditing ? 'lni lni-close' : 'lni lni-pencil';
        },
    },
    methods: {
        toggleEditForm() {
            this.isEditing = !this.isEditing;
            if (!this.isEditing) {
                this.loadUserProfile();
            }
        },
        toggleFormEditing() {
            this.formIsEditing = !this.formIsEditing;
            if (!this.formIsEditing && this.isEditing) {
                this.editProfileData = { ...this.user };
            }
        },
        async loadUserProfile() {
            try {
                const response = await PerfilService.getProfile();
                this.user = response;
                this.editProfileData = { ...this.user };
                if (this.user.imagenPerfil) {
                    this.profileImage = this.user.imagenPerfil.startsWith('http') ? this.user.imagenPerfil : `${config.API_URL}/${this.user.imagenPerfil}`;
                } else {
                    this.profileImage = require('@/assets/perfil.png');
                }
            } catch (error) {
                Swal.fire('Error', 'No se pudo cargar el perfil.', 'error');
            }
        },
        async updateProfile() {
            try {
                const response = await PerfilService.updateProfile(this.editProfileData);
                if (response.exito) {
                    await this.loadUserProfile();
                    this.formIsEditing = false;
                    Swal.fire('Éxito', 'Perfil actualizado correctamente.', 'success');
                } else {
                    Swal.fire('Error', response.data?.errores || 'Error al actualizar.', 'error');
                }
            } catch (error) {
                Swal.fire('Error', 'No se pudo actualizar el perfil.', 'error');
            }
        },
        navigateTo(route) {
            this.$router.push(route);
        },
        onFileSelect(event) {
            const file = event.target.files[0];
            if (file && file.type.startsWith('image/')) {
                this.originalFile = file; 
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageToCrop = e.target.result; 
                };
                reader.readAsDataURL(file);
            } else if (file) {
                Swal.fire('Error', 'Por favor, selecciona un archivo de imagen válido.', 'error');
            }
            event.target.value = null;
        },
        cropImage() {
            // Note: The ref name in template is 'cropperRef'
            if (!this.$refs.cropperRef) return;

            const { canvas } = this.$refs.cropperRef.getResult();
            if (canvas) {
                canvas.toBlob(async (blob) => {
                    if (blob) {
                        const croppedFile = new File([blob], this.originalFile.name, {
                            type: blob.type,
                            lastModified: Date.now()
                        });

                        try {
                            const response = await PerfilService.updateProfileImage(croppedFile);
                            if (response.exito) {
                                await this.loadUserProfile();
                                Swal.fire('¡Éxito!', 'Imagen de perfil actualizada con éxito.', 'success');
                            } else {
                                Swal.fire('Error', response.errores || 'Error desconocido al actualizar la imagen de perfil.', 'error');
                            }
                        } catch (error) {
                            Swal.fire('Error', error.message || 'Error al actualizar la imagen de perfil.', 'error');
                        } finally {
                            this.cancelCrop();
                        }
                    } else {
                         Swal.fire('Error', 'No se pudo obtener la imagen recortada (blob).', 'error');
                        this.cancelCrop();
                    }
                }, this.originalFile.type || 'image/jpeg', 0.9); // Quality for JPEG
            } else {
                Swal.fire('Error', 'No se pudo obtener el canvas recortado.', 'error');
                this.cancelCrop();
            }
        },
        cancelCrop() {
            this.imageToCrop = null;
            this.originalFile = null;
            // vue-advanced-cropper generally doesn't require manual destroy() if unmounted
        }
    },
    mounted() {
        this.loadUserProfile();
    },
};
</script>

<style scoped>
.profile-area {
    padding: 30px 0;
}

.profile-card {
    background: #f9f9f9;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    text-align: center;
    transition: box-shadow 0.3s ease-in-out;
}

.profile-card:hover {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.profile-image img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #ddd;
}

.upload-button {
    margin-top: 15px;
}

.upload-button input[type="file"] {
    display: none;
}

.upload-button label {
    cursor: pointer;
}

.profile-info {
    margin-top: 20px;
}

.profile-info .name {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
}

.profile-info .email,
.profile-info .phone {
    color: #777;
}

.profile-options {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-top: 20px;
}

.profile-options h3 {
    margin-bottom: 20px;
    font-size: 1.6rem;
    font-weight: 600;
    color: #333;
}

.options-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.option-card {
    background: #f0f0f0;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: background 0.3s ease, transform 0.3s ease;
}

.option-card:hover {
    background: #e0e0e0;
    transform: translateY(-5px);
}

.option-card i {
    font-size: 2rem;
    color: #007bff;
}

.option-card h4 {
    margin-top: 10px;
    font-size: 1.2rem;
    color: #333;
}

.profile-edit-form {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
}

.profile-edit-form h3 {
    margin-bottom: 20px;
    font-size: 1.6rem;
    font-weight: 600;
    color: #333;
}

.profile-edit-form .form-group {
    margin-bottom: 20px;
}

.profile-edit-form .form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.profile-edit-form .form-control {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #ddd;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.profile-edit-form .btn-primary {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
}

.profile-edit-form .btn-primary:hover {
    background-color: #0056b3;
}

.scroll-top {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #007bff;
    color: #fff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.scroll-top i {
    font-size: 1.5rem;
}

.scroll-top:hover {
    background-color: #0056b3;
}

.profile-info-area {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-top: 20px;
}

.profile-info-area h3 {
    margin-bottom: 15px;
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
}

.profile-info-area p {
    margin-bottom: 10px;
    font-size: 1rem;
    color: #555;
}

.profile-info-area ul {
    padding-left: 20px;
    margin-bottom: 20px;
}

.profile-info-area ul li {
    margin-bottom: 8px;
    font-size: 1rem;
    color: #555;
}

.profile-info-area ul li strong {
    font-weight: 600;
    color: #333;
}

.profile-info-area a {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;
}

.profile-info-area a:hover {
    text-decoration: underline;
}

.d-flex {
    display: flex;
    align-items: center;
    /* Center items vertically */
    justify-content: space-between;
    /* Space out items horizontally */
}

/* Estilos para el modal del cropper */
.cropper-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
    /* Asegúrate de que esté por encima de otros elementos */
}

.cropper-modal-content {
    background-color: #fff;
    padding: 25px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
    width: 90%;
    max-width: 600px;
    /* O el ancho que prefieras */
    display: flex;
    flex-direction: column;
}

.cropper-modal-content h3 {
    margin-top: 0;
    margin-bottom: 15px;
    text-align: center;
}

.cropper-container {
    width: 100%;
    margin-bottom: 20px;
    /* La altura se maneja en el style del componente vue-cropper */
}

.cropper-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    /* Espacio entre botones */
}

.cropper-actions .btn {
    padding: 10px 20px;
}

</style>